import BaseDataStore from '@/components/base/store/BaseDataStoreV1'

const BaseConst = {
  version: 1,
  storeName: 'S0901Policy',
  serviceName: 'S0901PolicyService'
}
const S0901Const = new BaseDataStore(BaseConst)
export default S0901Const
